export default __webpack_public_path__ + "static/media/menu5.4cfe2923.jpeg";